<template>
  <div class="container mx-auto px-4 fill-screen">
    <h1>Unauthorised</h1>
    <h4 class="mt-10">
      Resource Forbidden
    </h4>
    <br>
  </div>
</template>
